<template>
  <div>
    <p>Manage your loyalty card settings & QR codes</p>
    <a-row>
      <a-col :span="12">
        <a-card style="margin: 20px 0;" v-if="(businessId)">
          <p>Loyalty Program Name: <span>{{loyaltyProgram.name}}</span></p>
          <p>Status:
            <span>{{loyaltyProgram.status === 'new' ? 'INACTIVE' : 'LIVE'}}</span>
            <a-button type="primary" @click="toggleStatus">{{loyaltyProgram.status === 'new' ? 'SET LIVE' : 'SET INACTIVE'}}</a-button>
          </p>
          <p>Business Profile QR Code:</p>
          <div>
            <img :src="`${API_URL}/api/v3/business/${businessId}/qr`" alt="qr-code">
            <a-button :href="`${API_URL}/api/v3/business/${businessId}/qr`">Download</a-button>
          </div>
          <br><br>
          <div>
            <div>
              <p>Add points QR Code:</p>
              <img :src="`${API_URL}/api/v3/qr/${loyaltyQr.id}/download`" alt="qr-code">
              <a-button @click="newQr">Generate new QR Code</a-button>
              <a-button :href="`${API_URL}/api/v3/qr/${loyaltyQr.id}/download`">Download</a-button>
            </div>
            <p >Created: <span>{{qrDateFormatted}}</span></p>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import {API_URL} from '../../constants'
import moment from 'moment'

export default {
  name: 'ManageCard',
  data () {
    return {
      message: '',
      API_URL,
      qr: null,
    }
  },
  mounted () {
    this.$store.dispatch('loyalty/getLoyaltyData')
    this.$store.dispatch('loyalty/checkQr')
  },
  watch: {
    loyaltyQr (newQr) {
      if (!newQr) {

      }
    }
  },
  methods: {
    navigate (name) {
      this.$router.push({name})
    },
    toggleStatus () {
      this.$store.dispatch('loyalty/toggleStatus')
    },
    newQr () {
      this.$store.dispatch('loyalty/newQr')
    }
  },
  computed: {
    qrDateFormatted () {
      if (!this.loyaltyQr) {
        return ''
      }
      return moment(this.loyaltyQr.created_at).format('lll')
    },
    ...mapState({
      user: state => state.auth.user,
      loyaltyProgram: state => state.loyalty.loyaltyProgram,
      businessId: state => state.auth.user.business.id,
      loyaltyQr: state => state.loyalty.qr,
    }),
  },
}
</script>

<style lang="scss">
  @import "./../../assets/styles";
  .ant-input-number {
    margin:0 10px;
  }
  .ant-input {
    margin-bottom:15px;
  }
  .avatar-uploader > .ant-upload {
    width: 350px;
    height: 200px;
    margin: 20px auto;
  }
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }
  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/components/Loyalty/ManageCard.vue